// The word beside a real review score, the same on every page (Home's
// featured stays, the results, the property page). Below 3/5 the score and
// the count speak for themselves: no flattering word for a low score. The
// words are each page's own (i18n/stays hotelsL.scores).
export const RATING_WORDS = [["exceptional", 4.5], ["veryGood", 4], ["good", 3.5], ["pleasant", 3]];

export function ratingWord(rating, scores) {
  const hit = RATING_WORDS.find(([, min]) => Number(rating) >= min);
  return hit && scores ? scores[hit[0]] || null : null;
}
